// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.magic-token-page[data-v-892f753c] {\n\twidth: 100%;\n\tmin-height: 100vh;\n}\n", ""]);
// Exports
module.exports = exports;
